import { render, staticRenderFns } from "./ModalTableComponent.vue?vue&type=template&id=60efcf69"
import script from "./ModalTableComponent.vue?vue&type=script&lang=js"
export * from "./ModalTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports